import { useState } from "react";
import { normalizeThumbnailUrl } from "@/lib/thumbnailUrl";

const FALLBACK_SRC = "/video-fallback.jpg";

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

/**
 * Wrapper around <img> that swaps to a branded fallback image if the
 * original thumbnail fails to load (404, deleted, broken URL, etc.).
 * Also rewrites expiring YouTube signed thumbnail URLs to their stable form.
 */
export const VideoThumbnailImage = ({ src, alt, ...props }: Props) => {
  const [failed, setFailed] = useState(false);
  const resolved = failed ? FALLBACK_SRC : (normalizeThumbnailUrl(src) ?? FALLBACK_SRC);

  return (
    <img
      src={resolved}
      alt={alt}
      onError={() => setFailed(true)}
      {...props}
    />
  );
};

export default VideoThumbnailImage;

